import type { KadeweUser } from "~/types";

export const useFoth = () => {
    const route = useRoute();
    const user = useSanctumUser<KadeweUser>();

    const isFoth = computed(() => {
        return route.path.startsWith("/register/friends-of-the-house") || user.value?.foth.is_foth;
    });

    return {
        isFoth,
    };
};
